<!-- Banner Details Popup -->
<div *ngIf="showBannerDetailsPopup && energyBanner"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
  <div class="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200" [ngStyle]="energyBanner?.scriptSource">
      <div class="flex items-center space-x-3">
        @if (energyBanner?.icon) {
        <img [src]="energyBanner?.icon" alt="Banner Icon" class="w-fit h-6 object-contain">
        }
        <h2 class="text-xl md:text-2xl font-bold">{{energyBanner?.moreDetails?.title}}</h2>
      </div>
      <button (click)="closeBannerDetails()" type="button"
        class="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200">
        <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
          </path>
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="p-4 overflow-y-auto max-h-[calc(90vh-180px)]">
      <div class="space-y-4">
        <div *ngIf="energyBanner?.moreDetails?.displayText && energyBanner?.moreDetails?.displayText?.length > 0">
          <ul class="list-disc list-inside text-gray-700 leading-relaxed space-y-2">
            @for (content of energyBanner?.moreDetails?.displayText; track content) {
            <li> {{content}} </li>
            }
          </ul>
          @if (energyBanner?.moreDetails?.tnc) {
          <p class="mt-2 text-gray-700" [innerHTML]="energyBanner?.moreDetails?.tnc?.displayText"></p>
          }
        </div>

        <div *ngIf="energyBanner?.effectiveDate" class="pt-4 border-t border-gray-200">
          <p class="text-sm text-gray-600">
            <strong>Effective Date:</strong> {{ energyBanner?.effectiveDate | date: 'dd MMMM yyyy' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end p-6 border-t border-gray-200 bg-gray-50">
      <button (click)="closeBannerDetails()" type="button"
        class="px-6 py-2 bg-sp-green-500 hover:bg-sp-green-600 text-white font-semibold rounded-lg transition-all duration-200 shadow-sm hover:shadow-md">
        Close
      </button>
    </div>
  </div>
</div>

<!-- Energy Price Banner -->
@if (energyBanner) {
<div [ngClass]="isQuotePage ? 'p-4 md:p-5 mb-6 rounded-lg border' : 'px-4 py-3 md:p-5'" [ngStyle]="energyBanner?.scriptSource">
  <div class="flex flex-col md:flex-row md:items-center gap-3"
       [ngClass]="isQuotePage ? 'md:justify-between' : 'md:justify-center'">
    <div [ngClass]="isQuotePage ? 'flex-1' : ''">
      <div class="flex items-center space-x-3"
           [ngClass]="isQuotePage ? '' : 'justify-center'">
        <div class="flex-shrink-0">
          @if (energyBanner?.icon) {
          <img [src]="energyBanner?.icon" alt="Banner Icon" class="w-fit h-5 md:h-6 mt-0.5 object-contain">
          }
        </div>
        <div>
          @if (energyBanner?.title?.trim()) {
          <h3 class="font-bold text-sm md:text-base mb-1 uppercase tracking-wide">{{energyBanner?.title}}
          </h3>
          }
          <p class="text-sm md:text-base leading-relaxed">{{energyBanner?.displayText}}</p>
          @if (!isQuotePage) {
          <!-- Mobile only: keep the CTA aligned with the banner text -->
          <button (click)="openBannerDetails(energyBanner)" type="button"
            class="md:hidden inline-flex items-center mt-1 text-sm font-semibold transition-colors duration-200 whitespace-nowrap hover:underline">
            {{energyBanner?.moreDetails?.btnName}}
            <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
          }
        </div>
      </div>
    </div>
    <div [ngClass]="isQuotePage ? 'flex-shrink-0 md:ml-4' : 'hidden md:block'">
      <button (click)="openBannerDetails(energyBanner)" type="button"
        class="inline-flex items-center text-sm md:text-base font-semibold transition-colors duration-200 whitespace-nowrap hover:underline">
        {{energyBanner?.moreDetails?.btnName}}
        <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </button>
    </div>
  </div>
</div>
}